import React, { Component } from 'react'

export default class itService extends Component {
    render() {
        return (
         
<svg className={this.props.className} onClick={this.props.onClick} width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20.1504 3.66406H4.15039C3.04582 3.66406 2.15039 4.55949 2.15039 5.66406V15.6641C2.15039 16.7686 3.04582 17.6641 4.15039 17.6641H20.1504C21.255 17.6641 22.1504 16.7686 22.1504 15.6641V5.66406C22.1504 4.55949 21.255 3.66406 20.1504 3.66406Z" stroke="#001F82" strokeWidth="1.6" stroke-linecap="round" strokeLinejoin="round"/>
<path d="M8.15039 21.6641H16.1504" stroke="#001F82" strokeWidth="1.6" stroke-linecap="round" strokeLinejoin="round"/>
<path d="M12.1504 17.6641V21.6641" stroke="#001F82" strokeWidth="1.6" stroke-linecap="round" strokeLinejoin="round"/>
</svg>

        )
    }
}
